export function getAppConfig() {
    if (typeof window === 'undefined') {
        return {
            CLICK_OUT_URL: process.env.CLICK_OUT_URL,
            ACCOUNT_URL: process.env.ACCOUNT_URL,
            BASE_FORM_URL: process.env.BASE_FORM_URL,
            RELEASE_VERSION: process.env.RELEASE_VERSION,
            NAME_WHITELABEL: process.env.NAME_WHITELABEL,
        }
    }

    return window.appConfig
}
